export default __webpack_public_path__ + "assets/android-tablet.3f715ef0.svg";